import React, { useState, useEffect } from "react";
import { Edit, Trash2, Plus, RotateCcw } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import "./CountryList.css";

const url = process.env.REACT_APP_BACKEND_URL;

const CountryList = () => {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showInactive, setShowInactive] = useState(false);
  const navigate = useNavigate();

  const fetchCountries = async () => {
    try {
      setLoading(true);
      const endpoint = showInactive ? `${url}/api/country/all` : `${url}/api/country`;
      const res = await axios.get(endpoint);
      setCountries(res.data.data || []);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to fetch countries");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCountries();
  }, [showInactive]);

  const handleSoftDelete = async (id) => {
    if (window.confirm("Are you sure you want to deactivate this country?")) {
      try {
        const res = await axios.delete(`${url}/api/country/${id}`);
        toast.success(res.data.message || "Country deactivated successfully");
        fetchCountries();
      } catch (err) {
        toast.error(err.response?.data?.message || "Failed to deactivate country");
      }
    }
  };

  const handleRestore = async (id) => {
    if (window.confirm("Are you sure you want to activate this country?")) {
      try {
        const res = await axios.put(`${url}/api/country/${id}/restore`);
        toast.success(res.data.message || "Country activated successfully");
        fetchCountries();
      } catch (err) {
        toast.error(err.response?.data?.message || "Failed to activate country");
      }
    }
  };

  if (loading) return <div className="loading">Loading countries...</div>;

  return (
    <div className="country-container">
      <div className="header">
        <h2>Countries List</h2>
        <div className="header-actions">
          <button
            onClick={() => setShowInactive(!showInactive)}
            className={`toggle-button ${showInactive ? 'active' : ''}`}
          >
            {showInactive ? 'Showing All' : 'Show Active Only'}
          </button>
          <button
            onClick={() => navigate("/AddCountry")}
            className="add-button"
          >
            <Plus size={16} /> Add Country
          </button>
        </div>
      </div>

      <div className="table-responsive">
        <table className="country-table">
          <thead>
            <tr>
              {/* <th>No.</th> */}
              <th>Country Name</th>
              <th>Status</th>
              <th style={{ textAlign: "center" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {countries.length === 0 ? (
              <tr>
                <td colSpan="4" className="no-data">
                  No countries found
                </td>
              </tr>
            ) : (
              countries.map((country) => (
                <tr key={country._id} className={country.status === 'inactive' ? 'inactive-row' : ''}>
                  {/* <td>{country.no || country._id.slice(-4)}</td> */}
                  <td className="country-name">{country.name}</td>
                  <td>
                    <span className={`status-badge ${country.status}`}>
                      {country.status === 'active' ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td className="actions-cell">
                    <div className="actions">
                      {country.status === 'active' ? (
                        <>
                          <button
                            onClick={() => navigate(`/country/edit/${country._id}`)}
                            className="edit"
                            title="Edit"
                          >
                            <Edit size={16} />
                          </button>
                          <button
                            onClick={() => handleSoftDelete(country._id)}
                            className="delete"
                            title="Deactivate"
                          >
                            <Trash2 size={16} />
                          </button>
                        </>
                      ) : (
                        <button
                          onClick={() => handleRestore(country._id)}
                          className="restore-btn"
                          title="Activate"
                        >
                          <RotateCcw size={16} /> Activate
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CountryList;